import React, { useState, useEffect } from "react";

import queryString from "query-string";

import { Badge, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import {
  setUsersActions,
  getUsersActions,
  getUsersActionsFilters,
  setUsersActionsFilters
} from "../../../store/user-actions/actions";
import {
  getUsersToList,
} from "../../../store/user/user-list/actions";
import { getSelectedMonthAgoWithFirstDay, getSelectedMonthAgoWithLastDay, monthNames } from "../../../helpers/utils";
import ReactTableForm from "../../../components/Common/ReactTableForm";
import DynamicFormFilters from "../../../components/forms/DynamicFormFilters";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const UserActionsPage = (props) => {
  const defaultStyle = {
    textAlign: "center",
    width: "auto",
    verticalAlign: "middle",
  };

  const [date, setDate] = useState({
    start_date: getSelectedMonthAgoWithFirstDay(0),
    end_date: getSelectedMonthAgoWithLastDay(-1),
  });
  
  const [activeFilters, setActiveFilters] = useState({});

  useEffect(() => {
    props.getUsersActionsFilters();
    props.getUsersActions({
      sizePerPage: 10,
      page: 1
    });
    props.getUsersToList({
      sizePerPage: 0,
      page: 1
    });

    let parsedSearch = queryString.parse(props.history.location.search);
    let formattedSearch = {};

    for (const [key, value] of Object.entries(parsedSearch)) {
      if (value !== null) {
        formattedSearch[key] = value;
      }
    }

    if (formattedSearch?.start_date) {
      let dt = {
        start_date: formattedSearch?.start_date,
        end_date: formattedSearch?.end_date,
      };
      props.history.push({
        search: queryString.stringify(formattedSearch),
      });
    }
  }, []);

  const handleTableChange = data => {
    console.log(data);
    props.getUsersActions({
      ...props.data,
      ...data,
    });
  };

  const onFiltersChange = (filters, type, status) => {
    let params = {};
    if (!filters.user && !filters.action) {
      setActiveFilters({
        ...activeFilters,
        timestamp_gte: filters?.start_date ? `${filters?.start_date}` : ``,
        timestamp_lte: filters?.end_date ? `${filters?.end_date} 23:59:59` : ``,
      });
      params = {
        ...activeFilters,
        timestamp_gte: filters?.start_date ? `${filters?.start_date}` : ``,
        timestamp_lte: filters?.end_date ? `${filters?.end_date} 23:59:59` : ``,
      };
    } else {
      setActiveFilters({
        ...activeFilters,
        ...(filters?.user && { user: filters.user !== 'ALL' ? filters.user.join(',') : '', }),
        ...(filters?.action && { action: filters.action !== 'ALL' ? filters.action.join(',') : '' }),
      });
      params = {
        ...activeFilters,
        ...(filters?.user && { user: filters.user !== 'ALL' ? filters.user.join(',') : '', }),
        ...(filters?.action && { action: filters.action !== 'ALL' ? filters.action.join(',') : '' }),
      };
    }

    props.getUsersActions({
      ...props.data,
      ...params,
      user: params.user == 'ALL' ? '' : params.user || '',
      action: params.action == 'ALL' ? '' : params.action || '',
      page: 1
    });
  };

  const getStatusColorClass = (type) => {
    switch (type) {
      case 200:
        return 'bg-success';
      case 201:
        return 'bg-success';
      case 300:
        return 'bg-warning';
      case 400:
        return 'bg-warning';
      case 500:
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  };

  const handleStatusColor = (type) => {
    switch (type) {
      case 'GET':
        return (
          <StyledBadge className={"bg-primary"}>
            {type}
          </StyledBadge>
        );
      case 'POST':
        return (
          <StyledBadge className={"bg-success"}>
            {type}
          </StyledBadge>
        );
      case 'DELETE':
        return (
          <StyledBadge className={"bg-danger"}>
            {type}
          </StyledBadge>
        );
      case 'PATCH':
        return (
          <StyledBadge className={"bg-success"}>
            {type}
          </StyledBadge>
        );
      case 'PUT':
        return (
          <StyledBadge className={"bg-warning"}>
            {type}
          </StyledBadge>
        );
      default:
        return (
          <StyledBadge className={"bg-secondary"}>
            {type}
          </StyledBadge>
        );
    }
  };

  const handleDateRangeChange = filterDate => {
    let prevHistory = queryString.parse(props.history.location.search);
    let days = {
      start_date: filterDate.start_date,
    };

    let dt = {
      ...prevHistory,
      ...activeFilters,
      start_date: filterDate.start_date,
    };

    if (dt?.start_date && dt?.end_date) {
      let formQueryString = queryString.stringify(
        Object.assign(prevHistory, {
          ...days,
        })
      );

      props.history.push({ search: formQueryString });

      setActiveFilters({
        date: filterDate.start_date,
      });
    }
  };

  const onClickRow = (e, row) => {
    // props.history.push(`/invoices/${row.id}`);
  };

  const getDateText = dt => {
    let date = new Date(dt);
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    const formattedTime = `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

    return <>
      {formattedDate}{" "}
      <small>
        {formattedTime}
      </small>
    </>;
  };

  const cellProps = (info, test) => {
    return {
      style: {
        ...defaultStyle,
      },
    };
  };

  const getUsers = (data) => {
    let users = data.map((i) => {
      return {
        id: i.id,
        name: `${i.first_name} ${i.last_name}`
      };
    }) || [];

    return [{ id: 'ALL', name: "ALL" }, ...users];
  };

  const getUsersActions = (data) => {
    let actions = data.map((i) => {
      return {
        id: i,
        name: i
      };
    }) || [];

    return [{ id: 'ALL', name: "ALL" }, ...actions];
  };

  const columns = [
    {
      Header: "User",
      src: "user__first_name",
      isSorted: true,
      accessor: row => {
        return <span>
          {row.user_full_name}
        </span>;
      },
      style: {
        ...defaultStyle,
        maxWidth: 20,
        minWidth: 20,
      },
    },
    {
      Header: "Action",
      src: "action",
      isSorted: true,
      accessor: row => {
        return (
          <NameLink onClick={e => onClickRow(e, row, "edit")}>
            {row.action}
          </NameLink>
        );
      },
      style: {
        ...defaultStyle,
        maxWidth: 30,
        minWidth: 30,
      },
    },
    {
      Header: "Date",
      isSorted: true,
      src: "timestamp",
      accessor: row => {
        return (
          <NameLink onClick={e => onClickRow(e, row, "edit")}>
            {getDateText(row.timestamp)}
          </NameLink>
        );
      },
      style: {
        ...defaultStyle,
        maxWidth: 20,
        minWidth: 20,
      },
    },
  ];

  return (
    <MainStyle>
      <div className="page-content">
        <ModifiedMetaTags title="User Actions | Mobihunter" />
        <Container fluid>
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItem="User Actions"
            link="/dashboard"
          />
          <Row>
            <Col className="col-12">
              <Card>
                <DynamicFormFilters
                  filterDelay={10}
                  FilterContainerClass="rec--filters"
                  onFiltersChange={onFiltersChange}
                  onDateRangeChange={handleDateRangeChange}
                  disableFilterBy
                  filtered_params={queryString.parse(
                    props.history.location.search
                  )}
                  filtersFields={[
                    {
                      filterData: props.actionsFilters ? getUsersActions(props.actionsFilters) : [],
                      title: "Action",
                      plug: "Action...",
                      filterType: "action",
                      hasSelectAll: false,
                      singleSelect: true,
                      defaultValue: props.actionsFilters ? getUsersActions(props.actionsFilters)[0] : {},
                      style: {
                          marginLeft: "auto",
                        },
                    },
                    {
                      filterData: props.users?.results ? getUsers(props.users?.results) : [],
                      title: "Users",
                      plug: "Users...",
                      filterType: "user",
                      hasSelectAll: false,
                      singleSelect: true,
                      defaultValue: props.users?.results ? getUsers(props.users?.results)[0] : {},
                    },
                  ]}
                  filtered_by={["action", "user"]}
                  selectedDate={[]}
                  dateFilters={[
                    {
                      plug: "Date",
                      key: "date",
                      filterType: ["timestamp_gte", "timestamp_lte"],
                      clearDate: true,
                      dateRange: true,
                      customWidth: `200px`,
                      customStaticRanges: false,
                    },
                  ]}
                />
                <CardBody>
                    <ReactTableForm
                      columns={columns}
                      data={props.data}
                      onTableChange={handleTableChange}
                      // pagination
                      firstIsSticky
                    />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </MainStyle>
  );
};

const MainStyle = styled.div`
  .rec--filters {
  }
`;

const StyledBadge = styled(Badge)`
  font-size: 12px
  /* overflow-x: auto;
  .rec--table {
    min-width: 1200px;
  } */
`;

const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    /* color: rgb(85, 110, 230); */
    transition-duration: 0.1s;
  }
`;

UserActionsPage.propTypes = {
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  loader: PropTypes.bool,
  getUsersActions: PropTypes.func.isRequired,
  setUsersActions: PropTypes.func.isRequired,
  getUsersToList: PropTypes.func.isRequired,
  users: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  actionsFilters: PropTypes.array,
  filtersLoader: PropTypes.bool,
  getUsersActionsFilters: PropTypes.func.isRequired,
  setUsersActionsFilters: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  users: state.UsersList.data,
  permissions: state.User.permissions,
  data: state.UserActions.data,
  loader: state.UserActions.loading,
  actionsFilters: state.UserActions.actionsFilters,
  filtersLoader: state.UserActions.filtersLoader,
});

export default connect(mapStateToProps, {
  getUsersActions,
  setUsersActions,
  getUsersToList,
  getUsersActionsFilters,
  setUsersActionsFilters
})(UserActionsPage);
